module.exports = __webpack_public_path__ + "static/img/icon6-6.eebf5ca4.png";